import { AR_VOIDED_STATUSES } from '../../accounts-receivable/ar-voided-statuses.js';
/** Terminal statuses an order reaches without ever shipping, so it has no invoice document. */
export const NEVER_DELIVERED_SALES_ORDER_STATUS_IDS = new Set(AR_VOIDED_STATUSES);
//# sourceMappingURL=never-delivered-sales-order-status-ids.js.map